<template>
  <div class="ft">
    <div class="ft-content">
      <div class="our-stuff">
        <ul>
          <li>
            <a href="https://www.becketal.com/" target="_blank" rel="noopener">our site</a>
          </li>
          <li>
            <a href="https://medium.com/beck-et-al" target="_blank" rel="noopener">#our blog</a>
          </li>
        </ul>
      </div>

      <div class="social">
        <a
          href="https://www.linkedin.com/company/beck-et-al.-services/"
          target="_blank"
          rel="noopener"
        >
          <div class="linkedin">in</div>
        </a>
        <a href="https://twitter.com/Beck_et_al" target="_blank" rel="noopener">
          <img class="twitter" src="../assets/img/twitter.svg" alt height="30px" />
        </a>
        <a
          href="https://www.facebook.com/pages/Beck-et-al-Services/127672825067"
          target="_blank"
          rel="noopener"
        >
          <img class="facebook" src="../assets/img/facebook.svg" alt height="40px" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.ft {
  display: grid;
  grid-template-columns: 1fr 5fr 1fr;
  padding: 10px 0;
  margin-top: 50px;
  margin-bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  width: 100vw;
  a {
    color: $primary;
    text-decoration: none;
  }
}

.ft-content {
  grid-column: 2;
  text-align: left;
  max-width: 100vw;
  a {
    text-decoration: none;
    color: $primary;
  }
  ul {
    padding: 0;
    list-style: none;
  }
  .our-stuff {
    display: inline-block;
  }
  .social {
    display: block;
    position: relative;
    top: 20px;
    float: right;
  }
  .twitter {
    position: relative;
    bottom: 3px;
  }
  .linkedin {
    position: relative;
    margin: 0;
    padding: 0;
    bottom: 7px;
    right: 10px;
    letter-spacing: normal;
    font-weight: bold;
    font-size: 30px;
    display: inline-block;
  }
}

@media screen and (max-width: 700px) {
  .ft {
    grid-template-columns: auto;
  }
}

@media screen and (min-width: 1600px) {
  .ft {
    grid-template-columns: 1fr 2fr 1fr;
  }
}
</style>
